import { render, staticRenderFns } from "./EmbedPageOverlay.vue?vue&type=template&id=6e8bc186&scoped=true&"
import script from "./EmbedPageOverlay.vue?vue&type=script&lang=js&"
export * from "./EmbedPageOverlay.vue?vue&type=script&lang=js&"
import style0 from "./EmbedPageOverlay.vue?vue&type=style&index=0&id=6e8bc186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8bc186",
  null
  
)

export default component.exports